/*function debounce(func, wait = 150) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

let isUpdating = false;

function updateMegaMenuTop() {
    const headers = document.querySelectorAll('.shopify-section-group-header-group');
    const dropdowns = document.querySelectorAll('.mega-menu-cascade__dropdown');
    const stickyHeader = document.querySelector('.shopify-section-header-sticky');
    const specificHeader = document.getElementById('shopify-section-sections--25258744152406__header');

    let totalHeight = 0;

    headers.forEach(header => {
        const rect = header.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
            totalHeight += header.offsetHeight;
        }
    });

    dropdowns.forEach(dropdown => {
        dropdown.style.top = totalHeight + 'px';
    });

    if (stickyHeader && specificHeader) {
        specificHeader.style.top = stickyHeader.offsetHeight + 'px';
    }

    isUpdating = false; // resetăm flag-ul după update
}

function requestUpdateMegaMenuTop() {
    if (!isUpdating) {
        isUpdating = true;
        requestAnimationFrame(updateMegaMenuTop);
    }
}

const updateMegaMenuTopDebounced = debounce(updateMegaMenuTop, 150);

// -------------------- Evenimente --------------------
document.addEventListener('DOMContentLoaded', () => {
    updateMegaMenuTop();
    requestAnimationFrame(updateMegaMenuTop);
});

window.addEventListener('load', updateMegaMenuTop);
window.addEventListener('pageshow', updateMegaMenuTop);
window.addEventListener('scroll', requestUpdateMegaMenuTop);
window.addEventListener('resize', updateMegaMenuTopDebounced);
*/


document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('header a').forEach(link => {
    link.addEventListener('click', (e) => {
      if (link.getAttribute('href') === '#') {
        e.preventDefault();
      }
    });
  });

      
  // Restul codului JavaScript existent pentru desktop
  /*const list = document.querySelector('.mega-menu-cascade__level-3-list');

  if (list && list.children.length > 8) {
    list.classList.add('more-than-8');
    
    const parentDiv = list.parentElement; 
    if (parentDiv) {
      parentDiv.classList.add('has-many-items');
    }
  }*/

  const lists = document.querySelectorAll('.mega-menu-cascade__level-3-list');
  lists.forEach(list => {
    if (list.children.length > 8) {
      list.classList.add('more-than-8');
      const parentDiv = list.parentElement;
      if (parentDiv) {
        parentDiv.classList.add('has-many-items');
      }
    }
  });
  
  const level1Items = document.querySelectorAll(".mega-menu-cascade__list-item");

  level1Items.forEach(item => {
    const dropdown = item.querySelector(".mega-menu-cascade__dropdown");
    const level2Items = item.querySelectorAll(".mega-menu-cascade__level-2-item");
    
    // Selectăm listele de nivel 3 și div-ul pentru imagini din containerul desktop-only
    const desktopContent = item.querySelector(".mega-menu-cascade__level-3-wrapper.desktop-only");
    const level3Lists = desktopContent ? desktopContent.querySelectorAll(".mega-menu-cascade__level-3-list") : [];
    const imgDiv = desktopContent ? desktopContent.querySelector(".mega-menu-cascade__level-3-image") : null;

    if (!dropdown) return;

    // Hover pe Nivel 1
    item.addEventListener("mouseenter", () => {
      item.classList.add("active");
      dropdown.style.display = 'block';

      if (level3Lists.length > 0) {
        level3Lists.forEach(list => list.classList.remove("active"));
        if (level3Lists[0]) level3Lists[0].classList.add("active");

        const firstLevel2 = item.querySelector(`.mega-menu-cascade__level-2-item[data-index="0"]`);
        if (firstLevel2) firstLevel2.classList.add("active");

        // Populează imaginile pentru primul Nivel 2
        if (imgDiv && firstLevel2) {
          imgDiv.innerHTML = `
            ${firstLevel2.dataset['image-1'] ? `<a href="${firstLevel2.dataset['link-1'] || '#'}">
            <img src="${firstLevel2.dataset['image-1']}" alt="${firstLevel2.dataset['text-1'] || ''}">
            <div class="text-image">
            <span>${firstLevel2.dataset['text-1'] || ''}</span>
            <img class="arrow-icon" src="https://cdn.shopify.com/s/files/1/0762/7066/6070/files/formkit_arrowright_3.png?v=1755863066" alt="">
            </div>
            </a>` : ''}
            ${firstLevel2.dataset['image-2'] ? `<a href="${firstLevel2.dataset['link-2'] || '#'}">
            <img src="${firstLevel2.dataset['image-2']}" alt="${firstLevel2.dataset['text-2'] || ''}">
            <div class="text-image">
            <span>${firstLevel2.dataset['text-2'] || ''}</span>
            <img class="arrow-icon" src="https://cdn.shopify.com/s/files/1/0762/7066/6070/files/formkit_arrowright_3.png?v=1755863066" alt="">
            </div>
            </a>` : ''}
          `;
        }
      }
    });

    item.addEventListener("mouseleave", () => {
      item.classList.remove("active");
      dropdown.style.display = 'none';
      level2Items.forEach(l2 => l2.classList.remove("active"));
      if (imgDiv) imgDiv.innerHTML = '';
    });

    // Hover pe Nivel 2
    level2Items.forEach(level2 => {
      level2.addEventListener("mouseenter", function () {
        const index = this.dataset.index;

        // Ascunde toate Nivel 3 și arată Nivel 3 corespunzător
        if (level3Lists.length > 0) {
          level3Lists.forEach(list => list.classList.remove("active"));
          const target = desktopContent.querySelector(`.mega-menu-cascade__level-3-list[data-level2="${index}"]`);
          if (target) target.classList.add("active");
        }

        // Activează doar Nivel 2 curent
        level2Items.forEach(l2 => l2.classList.remove("active"));
        this.classList.add("active");
        console.log(this.dataset);
        // Nivel 1 rămâne activ
        item.classList.add("active");
        // Populează div-ul cu imagini din Nivel 2
        if (imgDiv) {
          imgDiv.innerHTML = `
            ${this.dataset['image-1'] ? `<a href="${this.dataset['link-1'] || '#'}">
            <img src="${this.dataset['image-1']}" alt="${this.dataset['text-1'] || ''}">
            <div class="text-image">
            <span>${this.dataset['text-1'] || ''}</span>
            <img class="arrow-icon" src="https://cdn.shopify.com/s/files/1/0762/7066/6070/files/formkit_arrowright_3.png?v=1755863066" alt="">
            </div>
            </a>` : ''}
            ${this.dataset['image-2'] && this.dataset['image-2'] !== this.dataset['image-1'] ? `<a href="${this.dataset['link-2'] || '#'}">
            <img src="${this.dataset['image-2']}" alt="${this.dataset['text-2'] || ''}">
            <div class="text-image">
            <span>${this.dataset['text-2'] || ''}</span>
            <img class="arrow-icon" src="https://cdn.shopify.com/s/files/1/0762/7066/6070/files/formkit_arrowright_3.png?v=1755863066" alt="">
            </div>
            </a>` : ''}
          `;
          console.log(imgDiv.innerHTML);
        }
      });
    });
  });
});